// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '@/assets/icon/iconfont.css'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
Vue.config.productionTip = false

import '@/assets/css/common/mobile.css';
import '@/assets/css/common/pc.less';
import '@/assets/font/font.css';

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
Vue.use(VueAwesomeSwiper)

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import 'vue-json-viewer/style.css'
import JsonViewer from 'vue-json-viewer'
Vue.use(JsonViewer)


import {
  Message,
  Modal
} from 'view-design'
Vue.prototype.$Message = Message
Vue.prototype.$Modal = Modal
import Bus from '@/utils/bus'
Vue.prototype.$Bus = Bus
import '@/assets/css/common/reset.css'
import 'view-design/dist/styles/iview.css'
// 引入vant
import 'vant/lib/index.css';
import {
  List,
  PullRefresh,
  Loading,
  Dialog,
  Popup,
  Tab,
  Tabs,
  Toast,
  DatetimePicker,
  Overlay,
  RadioGroup,
  Radio
} from 'vant'
Vue.use(List).use(PullRefresh).use(Loading).use(Dialog).use(Popup).use(Tab).use(Tabs).use(Toast).use(DatetimePicker)
  .use(Overlay).use(RadioGroup).use(Radio);
Vue.prototype.$dialog = Dialog;
Vue.prototype.$toast = Toast;

console.log('request', process.env)
import {
  getToken
} from '@/utils/auth'
Vue.prototype.$getToken = getToken
import moment from 'moment'
Vue.prototype.$moment = moment
// vue判断是否PC端 去除手机端适配
if (false && navigator.userAgent.match(
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
)) {
  Vue.prototype.$pc = false
} else {
  Vue.prototype.$pc = true
}
// 获取域名判断是否是代理商
  let url = window.location.href.split('?')[0]
  let domain = url.split('//')[1].split('/')[0]
  Vue.prototype.$domain = domain
/* eslint-disable no-new */
// 解决rodio切换时，aria-hidden属性未移除问题
Vue.directive('removeAriaHidden', {
  bind(el, binding) {
    let ariaEls = el.querySelectorAll('.el-radio__original');
    ariaEls.forEach((item) => {
      item.removeAttribute('aria-hidden');
    });
  }
});

new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js